import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function isQuestionLoadingSelector(state: IInitialState) {
	return moduleStateSelector(state).isQuestionLoading;
}
